const theme = {
  id: 'bluey',
  primary: '#FC9918', //orange
  secondary: '#F14A16', //rep orange
  background: '#370665', // purple
  third: '#35589A', // blue
  text: 'white',
};

export default theme;
